module.exports = __webpack_public_path__ + "img/poste de police.fa3cbe9b.png";